import {TripCollection} from "../Trip";
import bucuresti from "../../../assets/child/bucuresti.jpg";

const dayChildBucuresti: TripCollection = {
    imageSrc: bucuresti,
    trips: [
        {
            name: "1.1. Bucureşti I",
            route: "Braşov – Bucureşti – Braşov",
            days: [
                [
                    {
                        locationName: "Muzeul Naţional de Istorie Naturală “Grigore Antipa”",
                    },
                    {
                        locationName: "Muzeul Căilor Ferate Române",
                    },
                    {
                        locationName: "Muzeul Naţional al Satului “Dimitrie Gusti”",
                    },
                    {
                        locationName: "Parcul Regele Mihai I al României",
                    },
                    {
                        locationName: "Băneasa Shopping City",
                        details: "OPŢIONAL"
                    }
                ]
            ],
            notes: `Această excursie cuprinde o incursiune captivantă în lumea fascinantă a naturii și culturii 
            românești. Elevii vor explora Muzeul Național de Istorie Naturală "GrigoreAntipa", unde vor descoperi 
            diversitatea vieții sălbatice și evoluția planetei noastre. Apoi, vor călători în timp la Muzeul Căilor 
            Ferate Române, unde vor învăța despreistoria și importanța căilor ferate în dezvoltarea societății noastre. 
            În continuare, vor pătrunde în tradițiile și obiceiurile românești la Muzeul Național al Satului "Dimitrie 
            Gusti", iar excursia se va încheia cu o plimbare relaxantă în Parcul Regele Mihai I al României (Parcul 
            Herăstrău) sau la Băneasa Shopping City, unde vor avea ocazia să se relaxeze și să se distreze.`
        },
        {
            name: "1.2. Bucureşti II",
            route: "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Casa Memorială “Tudor Arghezi – Mărţişor”",
                        },
                        {
                            locationName: "Muzeul Naţional Tehnic “Dimitrie Leonida”",
                        },
                        {
                            locationName: "Muzeul Naţional al Literaturii Române",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes: `Descoperiți bogăția culturală și tehnică a Bucureștiului într-o excursie școlară memorabilă! 
            Elevii vor explora Casa Memorială „Tudor Arghezi – Mărțișor” pentru a cunoaște viața și opera renumitului poet, apoi vor pătrunde în universul inovator al științei la Muzeul Național Tehnic „Dimitrie Leonida”.
Continuând călătoria culturală, vor descoperi bogăția literaturii române la Muzeul Național al Literaturii, iar opțional, excursia se poate încheia la Băneasa Shopping City.`
        }
        ,
        {
            name: "1.3. Bucureşti III",
            route: "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Cotroceni",
                        },
                        {
                            locationName: "Muzeul Naţional de Istorie a României",
                        },
                        {
                            locationName: "Muzeul Naţional Tehnic “Dimitrie Leonida”",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes:
                `Explorați patrimoniul istoric și tehnic al Bucureștiului într-o excursie captivantă!
    Elevii vor fi fascinați de istoria și splendoarea Palatului Cotroceni, vor călători în timp
    la Muzeul Național de Istorie a României pentru a descoperi secretele trecutului
    nostru, iar apoi vor pătrunde în lumea inovatoare a tehnologiei la Muzeul Național
    Tehnic „Dimitrie Leonida”. Opțional, excursia se poate încheia la Băneasa Shopping
    City.`
        }
        ,
        {
            name: "1.4. Bucureşti IV",
            route:
                "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Casa Ceauşescu",
                        },
                        {
                            locationName: "Muzeul Naţional de Istorie a României",
                        },
                        {
                            locationName: "Observatorul Astronomic “Amiral Vasile Urseanu”",
                        },
                    ]
                ],
            notes:
                `Această excursie școlară vă oferă oportunitatea de a explora diverse aspecte ale
    Bucureștiului, de la istorie până la știință. Vizitați Casa Ceaușescu pentru a înțelege mai
    bine istoria recentă a României, apoi explorați artefactele și povestea din spatele lor la
    Muzeul Național de Istorie a României. Continuați călătoria prin observarea cerului şi a
    secretelor lui la Observatorul Astronomic Bucureşti.`
        }
        ,
        {
            name: "1.5. Bucureşti V",
            route:
                "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Parlamentului",
                        },
                        {
                            locationName: "Palatul Cotroceni",
                        },
                        {
                            locationName: "Muzeul Căilor Ferate Române",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes:
                `Descoperiți splendoarea și istoria Bucureștiului într-o excursie captivantă! Porniți într-o incursiune la Palatul Parlamentului, una dintre cele mai mari clădiri administrative din lume. Continuați călătoria cu o vizită la Palatul Cotroceni, sediul președinției României, oferind o privire în istoria și cultura țării
    noastre. Apoi, călătoriți în trecut la Muzeul Căilor Ferate Române, unde veți descoperi importanța și evoluția transportului feroviar în România. Opțional, excursia se poate încheia la Băneasa Shopping City.`
        }
        ,
        {
            name: "1.6. Bucureşti VI",
            route:
                "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Mogoşoaia",
                        },
                        {
                            locationName: "Palatul Cotroceni",
                        },
                        {
                            locationName: "Casa Experimentelor",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes:
                `Explorați istoria și inovația într-o excursie plină de aventură și descoperiri! Începeți
    călătoria la Palatul Mogoșoaia, un remarcabil monument istoric cu o arhitectură
    deosebită. Continuați cu o vizită la Palatul Cotroceni, unde veți explora bogata
    moștenire culturală și istorică a României. Apoi, îmbrățișați fascinanta știință la Casa
    Experimentelor, unde elevii vor avea ocazia să descopere principiile științifice într-un
    mod interactiv și captivant.`
        }
        ,
        {
            name: "1.7. Bucureşti VII",
            route:
                "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Mogoşoaia",
                        },
                        {
                            locationName: "Palatul Parlamentului",
                        },
                        {
                            locationName: "Casa Ceauşescu",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes:
                `Descoperiți istoria și eleganța
    Bucureștiului într-o excursie fascinantă!
    Începeți călătoria la Palatul Mogoșoaia, unul dintre cele mai frumoase monumente istorice din România, cu o
    arhitectură distinctivă și grădini impresionante. Continuați explorarea cu o vizită la Palatul Parlamentului, o
    capodoperă a arhitecturii românești și una dintre cele mai mari clădiri
    administrative din lume. Încheiați excursia la Casa Ceaușescu, unde veți
    avea ocazia să explorați locuința și viața fostului conducător al României
    comuniste. Acest traseu vă va oferi o perspectivă completă asupra istoriei și culturii bogate ale Bucureștiului.`
        }
        ,
        {
            name: "1.8. Bucureşti VIII",
            route:
                "Braşov – Bucureşti – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Palatul Mogoşoaia",
                        },
                        {
                            locationName: "Palatul Parlamentului",
                        },
                        {
                            locationName: "Muzeul Naţional de Istorie Naturală “Grigore Antipa”",
                        },
                        {
                            locationName: "Băneasa Shopping City",
                            details: "OPŢIONAL"
                        },
                    ]
                ],
            notes:
                ""
        }
        ,
    ]
}

export default dayChildBucuresti;